import { useCallback, useEffect, useState } from "react";
import * as API from "../apiConfig";
import { useOutletContext, useNavigate } from "react-router-dom";

function Dashboard() {
    const [counts, setCounts] = useState([]);
    const [loading, setLoading] = useState(true);

    const { authData } = useOutletContext();
    const authToken = authData?.token;

    const navigate = useNavigate();

    const FIXED_STAGES = [
        "Pending",
        "Processing",
        "Cutting",
        "Polishing",
        "Glass Cutting With Frosted",
        "Dispatched for Coloring",
        "Returned from Coloring",
        "Completed",
        "Delivered",
        "Billed"
    ];

    const getRequestHeaders = useCallback(() => {
        const headers = { "Content-Type": "application/json" };
        if (authToken) {
            headers.Authorization = `Bearer ${authToken}`;
        }
        return headers;
    }, [authToken]);

    const normalizeData = (apiData) => {
        const map = new Map();

        apiData.forEach(item => {
            map.set(item.status.toLowerCase(), item);
        });

        const result = FIXED_STAGES.map(stage => {
            const found = map.get(stage.toLowerCase());
            return found || {
                id: stage,
                status: stage,
                count: 0
            };
        });

        apiData.forEach(item => {
            if (!FIXED_STAGES.map(s => s.toLowerCase()).includes(item.status.toLowerCase())) {
                result.push(item);
            }
        });

        return result;
    };

    useEffect(() => {
        fetch(API.DASHBOARD_COUNTS_URL, {
            method: "GET",
            headers: getRequestHeaders(),
        })
            .then(res => res.json())
            .then(data => {
                setCounts(normalizeData(data));
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, [getRequestHeaders]);

    const getStatusColor = (status) => {
        switch (status.toLowerCase()) {
            case "pending": return "warning";
            case "processing": return "info";
            case "cutting": return "primary";
            case "polishing": return "secondary";
            case "delivered": return "success";
            case "billed": return "dark";
            default: return "dark";
        }
    };

    const totalOrders = counts.reduce((sum, item) => sum + item.count, 0);

    return (
        <div className="container-fluid">
            <div className="card shadow-sm border-0 rounded-4">
                <div className="card-body p-4 p-md-5">

                    {/* Header */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <div>
                            <p className="text-muted small mb-1 text-uppercase">Dashboard</p>
                            <h4 className="fw-semibold mb-0">Control Panel</h4>
                        </div>

                        <span className="badge bg-dark fs-6 px-3 py-2 rounded-pill">
                            Total Orders: {totalOrders}
                        </span>
                    </div>

                    {/* Loading */}
                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-dark" />
                        </div>
                    ) : (
                        <div className="row g-4">

                            {counts.map((item) => (
                                <div
                                    key={item.id}
                                    className="col-6 col-md-4 col-lg-3"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                        navigate(`/home/orders/stage/${encodeURIComponent(item.status)}`)
                                    }
                                >
                                    <div className={`card border-0 shadow-sm rounded-4 h-100 bg-${getStatusColor(item.status)}-subtle`}>
                                        <div className="card-body text-center">

                                            <h6 className="text-muted mb-2">
                                                {item.status}
                                            </h6>

                                            <h2 className="fw-bold mb-0">
                                                {item.count}
                                            </h2>

                                        </div>
                                    </div>
                                </div>
                            ))}

                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Dashboard;